import React, { useState, useEffect } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonLoading,
  IonToast,
  useIonViewWillEnter,
} from "@ionic/react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Divider,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  IconButton,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { Add, Delete, ExpandMore } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import {
  getBarInventory,
  getBarInventoryByBranch,
  getBarInventoryByBranch_empty,
  getProducts,
  getStewardInventory,
} from "../../../api/products/product";
import {
  addBarRequest,
  addStewardRequest,
  deleteRequestOrder,
  getAllBarRequestsWithItems,
  getMyBarRequestsWithItems,
  getStewardBarRequestsWithItems,
} from "../../../api/stock-transfer/stock-transfer";
import { getUser, getUserData, requestID } from "../../../common/utils";

const StyledCard = styled(Card)(({ theme }) => ({
  margin: theme.spacing(2),
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[3],
}));

interface RequestItem {
  id: string;
  product_id: string;
  product_name: string;
  quantity: number;
  status?: string;
}

const StewardRequestPage_branch: React.FC = () => {
  const [products, setProducts] = useState<any[]>([]);
  const [requestItems, setRequestItems] = useState<RequestItem[]>([]);
  const [currentProduct, setCurrentProduct] = useState("");
  const [currentQuantity, setCurrentQuantity] = useState<Number>("");
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [userRequests, setUserRequests] = useState<any[]>([]);
  const [stockCount, setStockCount] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);

  useEffect(() => {
    fetchProducts();
    fetchUserRequests();
  }, []);


  useIonViewWillEnter(() => {
    fetchProducts();
    fetchUserRequests();
  });
  const fetchProducts = async () => {
    setLoading(true);
    try {
      const response = await getBarInventoryByBranch_empty();
      setProducts(response.data);
      console.log(response);
      console.log("Fetched products:", response.totalStockCount);
      setStockCount(response.totalStockCount);
      //setProducts(response.totalStockCount);
    } catch (error) {
      console.log(error);
      setToastMessage("Failed to fetch products");
      setShowToast(true);
    } finally {
      setLoading(false);
    }
  };

  const deleteRequest = async (request_id) => {
    const data = {
      request_id: request_id,
      //   requestID: requestID(),
    };

    setLoading(true);

    try {
      const response = await deleteRequestOrder(data);
      console.log("Delete response:", response);
      // setProducts(response.data);
      //console.log('Fetched products:', response.totalStockCount);
      //setStockCount(response.totalStockCount);
      //setProducts(response.totalStockCount);
    } catch (error) {
      console.log(error);
      setToastMessage("Failed delete");
      setShowToast(true);
    } finally {
      setLoading(false);
    }
  };

  const fetchUserRequests = async () => {
    try {
      const response = await getStewardBarRequestsWithItems();
      setUserRequests(response.data.data);
    } catch (error) {
      setToastMessage("Failed to fetch your requests");
      setShowToast(true);
    }
  };

  const addRequestItem = () => {
    if (!currentProduct || !currentQuantity) return;

    const selectedProduct = products.find(
      (p) => p.product_id === currentProduct
    );
    if (!selectedProduct) return;

    const newItem: RequestItem = {
      id: Date.now().toString(),
      product_id: currentProduct,
      product_name: selectedProduct.name,
      quantity: parseInt(currentQuantity),
    };

    setRequestItems([...requestItems, newItem]);
    setCurrentProduct("");
    setCurrentQuantity("");
  };

  const removeRequestItem = (id: string) => {
    setRequestItems(requestItems.filter((item) => item.id !== id));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (requestItems.length === 0) {
      setToastMessage("Please add at least one item to request");
      setShowToast(true);
      return;
    }

    setLoading(true);

    try {
      await addStewardRequest(requestItems);
      setToastMessage("Request submitted successfully!");
      setRequestItems([]);
      fetchUserRequests();
    } catch (error) {
      setToastMessage("Error submitting request");
    } finally {
      setLoading(false);
      setShowToast(true);
    }
  };
  //   const totalQuantity1 = requestItems.reduce(
  //   (acc, item) => acc + Number(item.quantity),
  //   0
  // );

  const getTotalQuantity = (currentInput) => {
    setTotalQuantity(0);
    const total = requestItems?.reduce(
      (acc, item) => acc + Number(item.quantity || 0),
      0
    );
    setTotalQuantity(Number(total + Number(currentInput) || 0));
  };

  useEffect(() => {
    setTotalQuantity(0);
    const total = requestItems?.reduce(
      (acc, item) => acc + Number(item.quantity || 0),
      0
    );
    setTotalQuantity(Number(total));
  }, [requestItems]);
  const savingsLimit = Number(getUser().userData?.savingsCount) || 0;
  const totalIfAdded = Number(stockCount) + Number(currentQuantity);
  const exceedsLimit = totalIfAdded > savingsLimit;
  const totalExceedsLimit =
    Number(stockCount) + Number(totalQuantity) > savingsLimit;

  const currentQty = Number(currentQuantity) || 0;

  console.log("exceedsLimit :", exceedsLimit);
  console.log(
    "totalExceedsLimit :",
    Number(stockCount) + Number(totalQuantity) + "--" + totalExceedsLimit
  );

  const handleCancel = async (requestId: string) => {
    //setLoading(true);
    console.log("Cancelling request:", requestId);
    setUserRequests(
      userRequests.filter(
        (userRequests) => userRequests.request_id !== requestId
      )
    );

    deleteRequest(requestId);
  };

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedRequestId, setSelectedRequestId] = useState(null);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{totalIfAdded}Steward Stock Request</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <StyledCard>
          <CardContent>
            <Typography variant="h5" component="h2" gutterBottom>
              Create New Request
            </Typography>

            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={5}>
                  <FormControl fullWidth>
                    <InputLabel id="product-label">Product</InputLabel>
                    <Select
                      labelId="product-label"
                      value={currentProduct}
                      label="Product"
                      onChange={(e) => setCurrentProduct(e.target.value)}
                    >
                      {products?.map((product) => (
                        <MenuItem key={product.id} value={product.product_id}>
                          {product.name} ({product.qty} available)
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Quantity"
                    type="number"
                    value={currentQuantity}
                    onChange={(e) => {
                      setCurrentQuantity(Number(e.target.value) || 0),
                        getTotalQuantity(e.target.value);
                    }}
                    inputProps={{ min: 1 }}
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  {/* {stockCount} */}
                  {/* {(getUser().userData?.savingsCount)} */}
                  {/* <Tooltip
  title={
    stockCount >= Number(getUser().userData?.savingsCount)
      ? `You cannot add more than ${Number(getUser().userData?.savingsCount)} items`
      : (!currentProduct || !currentQuantity)
        ? "Please select a product and quantity"
        : ""
  }
  placement="top"
  arrow
>
  <span style={{ width: '100%' }}>
    <Button
      fullWidth
      variant="outlined"
      startIcon={<Add />}
      onClick={addRequestItem}
      disabled={
        !currentProduct ||
        !currentQuantity ||
        stockCount >= Number(getUser().userData?.savingsCount)
      }
    >
      Add Item
    </Button>
  </span>
</Tooltip> */}

                  {/* {stockCount >= savingsLimit ? (
  <Typography
    variant="body1"
    fontWeight="bold"
    color="error"
    textAlign="center"
    sx={{ mt: 1, mb: 1 }}
  >
    You have reached the maximum allowed items: {savingsLimit}
  </Typography>
) : (
  <Tooltip
    title={
      (!currentProduct || !currentQuantity)
        ? "Please select a product and quantity"
        : ""
    }
    placement="top"
    arrow
  >
    <span style={{ width: '100%' }}>
      <Button
        fullWidth
        variant="outlined"
        startIcon={<Add />}
        onClick={addRequestItem}
        disabled={
          !currentProduct ||
          !currentQuantity
        }
      >
        Add Item
      </Button>
    </span>
  </Tooltip>
)} */}

                  {/* {totalExceedsLimit || exceedsLimit ? (
                    <Typography
                      variant="body2"
                      color="error"
                      fontWeight="bold"
                      sx={{ mt: 1 }}
                    >
                      You cannot exceed the maximum limit of {savingsLimit}{" "}
                      items.
                    </Typography>
                  ) : null} */}
                  <Tooltip
                    title={
                      
                        "Please select a product and quantity"
                        
                    }
                    placement="top"
                    arrow
                  >
                    <span style={{ width: "100%" }}>
                      <Button
                        fullWidth
                        variant="outlined"
                        startIcon={<Add />}
                        onClick={addRequestItem}
                        // disabled={
                        //   !currentProduct ||
                        //   !currentQuantity ||
                        //   totalExceedsLimit ||
                        //   exceedsLimit
                        // }
                      >
                        Add Item
                      </Button>
                    </span>
                  </Tooltip>

                  {/* {totalExceedsLimit && (
  <Typography
    variant="body2"
    color="error"
    fontWeight="bold"
    sx={{ mt: 1 }}
  >
    You cannot exceed the maximum limit of {savingsLimit} items.
  </Typography>
)} 

<Tooltip
  title={
    totalExceedsLimit
      ? `Cannot add more than ${savingsLimit} items`
      : (!currentProduct || !currentQuantity)
        ? "Please select a product and quantity"
        : ""
  }
  placement="top"
  arrow
>
  <span style={{ width: '100%' }}>
    <Button
      fullWidth
      variant="outlined"
      startIcon={<Add />}
      onClick={addRequestItem}
      disabled={
        !currentProduct ||
        !currentQuantity ||
        totalExceedsLimit
      }
    >
      Add Item
    </Button>
  </span>
</Tooltip>
*/}
                </Grid>
              </Grid>

              {requestItems.length > 0 && (
                <TableContainer component={Paper} sx={{ mt: 3 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Product</TableCell>
                        <TableCell align="right">Quantity</TableCell>
                        <TableCell align="right">Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {requestItems?.map((item) => (
                        <TableRow key={item.id}>
                          <TableCell>{item.product_name}</TableCell>
                          <TableCell align="right">{item.quantity}</TableCell>
                          <TableCell align="right">
                            <IconButton
                              size="small"
                              onClick={() => removeRequestItem(item.id)}
                            >
                              <Delete fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    {/* Total Row */}
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Total</TableCell>
                      <TableCell align="right" sx={{ fontWeight: "bold" }}>
                        {requestItems?.reduce(
                          (acc, item) => acc + Number(item.quantity),
                          0
                        )}
                      </TableCell>
                      <TableCell />
                    </TableRow>
                  </Table>
                </TableContainer>
              )}

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2, py: 1.5 }}
                disabled={loading || requestItems.length === 0}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Submit Request"
                )}
              </Button>
            </Box>
          </CardContent>
        </StyledCard>
        <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
          <DialogTitle>Confirm Cancellation</DialogTitle>
          <DialogContent>
            Are you sure you want to cancel this request?
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmOpen(false)} color="inherit">
              No
            </Button>
            <Button
              onClick={() => {
                handleCancel(selectedRequestId);
                setConfirmOpen(false);
              }}
              color="error"
            >
              Yes, Cancel
            </Button>
          </DialogActions>
        </Dialog>

        <StyledCard>
          <CardContent>
            <Typography variant="h5" component="h2" gutterBottom>
              My Requests
            </Typography>

            {userRequests?.length === 0 ? (
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ textAlign: "center", py: 3 }}
              >
                No requests found
              </Typography>
            ) : (
              userRequests?.map((request) => (
                <Accordion key={request.request_id} sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        alignItems: "center",
                      }}
                    >
                      <Typography>
              
                        Request #{request.request_id}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                               { request.status != "approved" && (

 <Chip
                          label="Cancel"
                          size="small"
                          color="error"
                          onClick={() => {
               setSelectedRequestId(request.request_id);
                            setConfirmOpen(true);
                          }}
                          sx={{ mr: 2 }}
                        />
                     )
                    }
                        <Chip
                          label={request.status}
                          size="small"
                          color={
                            request.status === "approved"
                              ? "success"
                              : request.status === "rejected"
                              ? "error"
                              : "warning"
                          }
                          sx={{ mr: 2 }}
                        />

                        <Typography variant="caption">
                          {new Date(request.created_at).toLocaleString()}
                        </Typography>
                      </Box>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Product</TableCell>
                            <TableCell align="right">Requested Qty</TableCell>
                            <TableCell align="right">Approved Qty</TableCell>
                            <TableCell align="center">Status</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {request?.items?.map((item: any, i) => (
                            <TableRow key={i}>
                              <TableCell>{item.name}</TableCell>
                              <TableCell align="right">
                                {item.quantity}
                              </TableCell>
                              <TableCell align="right">
                                {item.quantity_approved || "-"}
                              </TableCell>
                              <TableCell align="center">
                                <Chip
                                  label={item.status}
                                  size="small"
                                  color={
                                    item.status === "approved"
                                      ? "success"
                                      : item.status === "rejected"
                                      ? "error"
                                      : "warning"
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </Accordion>
              ))
            )}
          </CardContent>
        </StyledCard>

        <IonLoading isOpen={loading} message={"Processing..."} />
        <IonToast
          isOpen={showToast}
          onDidDismiss={() => setShowToast(false)}
          message={toastMessage}
          duration={2000}
        />
      </IonContent>
    </IonPage>
  );
};

export default StewardRequestPage_branch;
